import api from "./api";
import CoursePlaceholder from "../assets/images/coursePlaceholder.png";

const findNotificationsRequest = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: [
          {
            id: 1,
            image: CoursePlaceholder,
            message: "Seu curso Lorem Ispum ainda tem exercícios para serem finalizados!",
            new: true,
          },
          {
            id: 2,
            image: CoursePlaceholder,
            message: "Seu curso Lorem Ispum já está disponível! Venha aprender!",
          },
          {
            id: 3,
            image: CoursePlaceholder,
            message: "Seu boleto para pagamento do curso Lorem ispum vence hoje. Não perca tempo e comece já!",
          },
        ],
      });
    }, 1500);
  });
  // return api.get('notificacoes');
};

const clearNotificationsRequest = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: "ok",
      });
    }, 1500);
  });
  // return api.get('notificacoes');
};

const NotificationRequest = (data) => {
  return api.post(`api/notification`, data);
};

const CourseNotificationRequest = (data) => {
  return api.post(`api/notification/course`, data);
};

export { findNotificationsRequest, clearNotificationsRequest, NotificationRequest, CourseNotificationRequest };
